import { useEffect, useState } from 'react'
import { Container, Row, Col, Modal, Button, Card } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import { useAuth } from '../../components/auth/useAuth'
import { getZones, addZone, editZone } from '../../actions/other/zonesActions'
import { getForSelect } from '../../actions/other/farmsActions'
import { CustomDataTable } from '../../components/design/Datatables/CustomDataTable'
import Swal from 'sweetalert2'
import Loader from '../../components/loaders/Loader'
import ZoneForm from '../../components/forms/ZoneForm'

export default function Zones() {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const {clientauth} = useAuth()

    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(25)
    const [search, setSearch] = useState('')
    const [searchAux, setSearchAux] = useState('')
    const [totalRows, setTotalRows] = useState(0)

    const {zone, zones, resultzone, loading, total} = useSelector(state=>state.zones)
    const {farmsForSelect} = useSelector(state=>state.farms)

    const [modalShow, setModalShow] = useState(false)
    const [formState, setFormState] = useState({})
    const [isRegistering, setIsRegistering] = useState(false)
    const [isAddingOrEditing, setIsAddingOrEditing] = useState(false)

    useEffect(() => {
        if(clientauth){
            dispatch(getZones(page, limit, search))
            dispatch(getForSelect())
        }
    },[dispatch, t, clientauth])

    useEffect(() => {
        if (clientauth) {
            dispatch(getZones(page, limit, search))
        }
    }, [page, limit, search])

    const openModal = () =>{
        setIsAddingOrEditing('adding')
        setFormState({})
        setModalShow(true)
    }

    const selectZone = (zone) => {
        setFormState({...zone})
        setIsAddingOrEditing('editing')
        setModalShow(true)
    }

    const handleInputChange = ({target})=>{
        setFormState({
            ...formState,
            [target.name]: target.value
        })
    }

    const handleSubmit= async(e) => {
        e.preventDefault()
        setIsRegistering(true)

        if(isAddingOrEditing==='editing'){
            dispatch(editZone(formState, formState._id))
        }else{
            dispatch(addZone(formState))
        }
        setIsRegistering(false)
    }

    useEffect(() => {
        if(resultzone){
            let resultzonenow = resultzone
            dispatch({ type: 'ZONE_RESET_RESULT' })
            switch (resultzonenow) {
                case 'success':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('admin.zone.addsuccess')
                    }).then(() => {
                        setModalShow(false)
                        setIsAddingOrEditing(false)
                    })
                    break;
                case 'needMoreData':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.ok'),
                        icon: 'warning',
                        text: t('admin.zone.needMoreData')
                    })
                    break;
                case 'editSuccess':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('admin.zone.editSuccess')
                    }).then(() => {
                        setModalShow(false)
                        setIsAddingOrEditing(false)
                    })
                    break;
                default:
                    break;
            }
        }
    // eslint-disable-next-line
    }, [resultzone])

    const columnsZone = [
        {
            name: t('admin.zone.name'),
            cell: zone =>
                <div className='cursor' onClick={() => selectZone(zone)}>
                    {zone.name}
                </div>,
            selector: (zone) => zone.name,
            sortable: true,
        },{
            name: t('admin.zone.type'),
            cell: zone =>
                <div className='cursor' onClick={() => selectZone(zone)}>
                    {t('admin.zone.type_'+zone.type)}
                </div>,
            selector: (zone) => t('admin.zone.type_'+zone.type) || zone.type,
            sortable: true,
        },{
            name: t('admin.zone.surface'),
            cell: zone =>
                <div className='cursor' onClick={() => selectZone(zone)}>
                    {zone.surface}
                </div>,
            selector: (zone) => zone.surface,
            sortable: true,
        },{
            name: t('admin.zone.farm'),
            cell: zone =>
                <div className='cursor' onClick={() => selectZone(zone)}>
                    {zone.farm?.name}
                </div>,
            selector: (zone) => zone.farm,
            sortable: true,
        },{
            name: '',
            width: '100px',
            cell: zone =>
                <div className='cursor' onClick={() => selectZone(zone)}>
                    <i className='fas fa-pencil'></i>
                </div>,
            sortable: false,
        }
    ]

    return (
        <Container className='p-5'>
            <Row>
                <Col xs={12}>
                    <h1>{t('admin.zone.zones')}</h1>
                </Col>
                <Col xs={12} className='d-flex justify-content-end'>
                    <Button variant='primary' type="submit" className="my-2 cursor" onClick={() => openModal()}>
                        <i className="fas fa-plus me-2"></i>  {t('admin.zone.createzone')}
                    </Button>
                </Col>
            </Row>
            <Row>
                <Col xs={12} className='my-3'>
                    {loading ?
                        <Loader/>
                    :
                        <Row>
                            <Col>
                                <Card>
                                    <Card.Body>
                                        <div className="d-flex my-2">
                                            <input
                                                type="text"
                                                className="form-control me-2"
                                                placeholder={t("datatables.buscar")}
                                                value={searchAux || ""}
                                                onChange={e => {
                                                    setSearchAux(e.target.value);
                                                    setPage(1);
                                                }}
                                                onKeyDown={(e) => {if (e.key === 'Enter') { setSearch(searchAux); setPage(1); }}}
                                            />
                                            <Button onClick={() => setSearch(searchAux)}><i className='fas fa-search'></i></Button>
                                        </div>
                                        {zones?.length > 0 ?
                                            <CustomDataTable
                                                columns={columnsZone}
                                                data={zones}
                                                pagination
                                                paginationServer
                                                paginationTotalRows={totalRows}
                                                searchText={search}
                                                onChangeRowsPerPage={(newLimit, page) => {
                                                    if (limit !== newLimit) {
                                                        setLimit(newLimit)
                                                        setPage(1)
                                                    }
                                                }}
                                                onChangePage={(newPage) => {
                                                    setPage(newPage)
                                                }}
                                            />
                                        :
                                            <h4 className='mt-4'>{t('admin.zone.thereisnotzone')}</h4>
                                        }
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    }
                </Col>
            </Row>
            <Modal
                show={modalShow}
                onHide={() => setModalShow(false)}
                aria-labelledby="contained-modal-title-vcenter"
                size="lg"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        <h2>{t('admin.zone.zone')}</h2>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ZoneForm
                        state={formState}
                        zonetype={'admin'}
                        handleInputChange={handleInputChange}
                        submit={handleSubmit}
                        isAddingOrEditing={isAddingOrEditing}
                        isRegistering={isRegistering}
                        farmOptions={farmsForSelect}
                    />
                </Modal.Body>
            </Modal>
        </Container>
    )
}